export default "__VITE_ASSET__c0447d96__"